import React from 'react';
import moment from 'moment';
import styled from 'styled-components';

const Table = styled.table`
	margin: 20px 0;
	font-size: 1.4em;
	color: #707070;
	
	thead {
	  color: #B2B2B2;
	  
	  th {
	    border: 0;
	  }
	}
	
	th i {
	  	font-size: 1.6em;
    	margin-right: 7px;
	}
	
	th, td {
	    vertical-align: middle;
	}
	
	tr td {

	  button.btn-danger {
	      background-color: #FF003C;
	      border-color: #FF003C;
	      font-size: 1em;
	      padding: 8px 20px;
	      
	      &:hover {
	        background: #ffffff;
	        color: #FF003C;
	      }
	  }
	  
	  button.btn-simple {
	      background-color: #707070;
	      border-color: #707070;
	      font-size: 1em;
	      padding: 8px 20px;
	      color: #ffffff;
	      
	      &:hover {
	        background: #ffffff;
	        color: #707070;
	      }
	  }
	}
`;

const btnClickAction = (e, button, row) => {
	if (typeof button.onClick === 'function') {
		button.onClick(row);
	}
};

const renderThead = (tbody, thead) => {
	if (tbody.length === 0) {
		return (
			<tr>
				<th>Nenhum briefing disponível</th>
			</tr>
		);
	}
	return (
		<tr>
			{thead.map(data => (
				<th key={data} scope="col">{data}</th>
			))}
		</tr>
	);
};

const getCombo = (combo) => {
	const comboArr = combo.split('-');
	return comboArr[0];
};

const List = (props) => {
	const {
		dataThead, dataTbody, button, loading,
	} = props;
	return (
		<Table className="table m-auto">
			<thead>
				{loading ? (
					<tr>
						<th>Carregando briefings...</th>
					</tr>
				) : renderThead(dataTbody, dataThead)}
			</thead>
			<tbody>
				{
					dataTbody.map(briefing => (
						<tr key={briefing.pre_sale_id}>
							<th scope="row"><i className="far fa-file-alt" /> {briefing.pre_sale_id}</th>
							<td>{moment(briefing.pre_sale_date).format('DD/MM/YYYY')}</td>
							{
								dataThead.includes('Data Preenchimento:') && (<td>{moment(briefing.last_update).format('DD/MM/YYYY')}</td>)
							}
							<td>{briefing.sale_net_value}</td>
							<td>{`${briefing.duration} meses`}</td>
							<td>{ briefing.product.combo ? getCombo(briefing.product.combo) : ' - '}</td>
							<td>
								<button type="button" onClick={e => btnClickAction(e, button, briefing)} className={`btn ${button.classButton} float-right`}>{button.value}</button>
							</td>
						</tr>
					))
				}
			</tbody>
		</Table>
	);
};

export default List;
